import React, { useEffect, useReducer } from 'react';
import get from 'lodash/get';
import { getAppData } from 'api';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { LoadingScreen } from 'msp-components';
import Analytics from 'components/Analytics';
import PlayerWrapper from 'components/PlayerWrapper';
import WebsiteWrapper from 'components/WebsiteWrapper';
import WebsiteWrapperCustomNav from 'components/WebsiteWrapperCustomNav';
import ErrorBoundary from 'components/ErrorBoundary';
import styles from './App.module.scss';

const appDataReducer = (state, action) => {
  switch (action.type) {
    case 'request':
      return { ...state, isFetching: true };
    case 'success':
      return { data: action.payload, isFetching: false, error: null };
    case 'failure':
      return { error: action.payload, isFetching: false, data: null };
    default:
      throw new Error();
  }
};

const getWrapperComponent = appData => {
  if (!appData || !appData.project || !appData.project.type) {
    return null;
  }

  const type = appData.project.type.toLowerCase();

  if (type === 'player') {
    return PlayerWrapper;
  } else if (type === 'website') {
    return appData.useCustomNav ? WebsiteWrapperCustomNav : WebsiteWrapper;
  }
};

const App = () => {
  const [state, dispatch] = useReducer(appDataReducer, { isFetching: false, data: null, error: null });
  useEffect(() => {
    const handleRequest = () => dispatch({ type: 'request' });
    const handleSuccess = data => dispatch({ type: 'success', payload: data });
    const handleFailure = error => dispatch({ type: 'success', payload: error });
    getAppData(handleRequest, handleSuccess, handleFailure);
  }, []);

  const { isFetching, data, error } = state;
  error && console.error(error);
  /* eslint-disable react/prop-types */
  const Router = get(data, 'project.disableHistory', false)
    ? ({ children }) => <HashRouter>{children}</HashRouter>
    : ({ children }) => <BrowserRouter basename={window.BASE_PATH}>{children}</BrowserRouter>;
  /* eslint-enable react/prop-types */

  const Wrapper = getWrapperComponent(data);

  return (
    <div className={styles.wrapper}>
      <ErrorBoundary>
        {isFetching || !data ? (
          <LoadingScreen />
        ) : (
          <Router>
            {data.project && data.project.analyticsId ? (
              <Analytics analyticsProvider={data.project.analyticsProvider} analyticsId={data.project.analyticsId}>
                <Wrapper {...data} />
              </Analytics>
            ) : (
              <Wrapper {...data} />
            )}
          </Router>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default App;
